const SvgAssetManagement2 = (props) => (
  <>
    <path
      d="M48 121c12.68 0 23 10.32 23 23s-10.32 23-23 23-23-10.32-23-23 10.32-23 23-23m0-25c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48ZM144 121c12.68 0 23 10.32 23 23s-10.32 23-23 23-23-10.32-23-23 10.32-23 23-23m0-25c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48Z"
      fill={props.p20}
    />
    <path
      d="M96 41c12.68 0 23 10.32 23 23s-10.32 23-23 23-23-10.32-23-23 10.32-23 23-23m0-25c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48Z"
      fill={props.p20}
    />
    <path fill="none" stroke={props.p30} strokeMiterlimit={10} d="M48 144h96L96.01 64 48 144z" />
    <path
      d="M146.91 146.91c3.28-4.3-1.53-9.11-5.83-5.83-3.28 4.3 1.53 9.11 5.83 5.83ZM50.91 146.91c3.28-4.3-1.53-9.11-5.83-5.83-3.28 4.3 1.53 9.11 5.83 5.83ZM98.91 66.91c3.28-4.3-1.53-9.11-5.83-5.83-3.28 4.3 1.53 9.11 5.83 5.83Z"
      fill={props.p30}
    />
  </>
);

export default SvgAssetManagement2;
